<!--
 * @Author: v_hllhe
 * @Date: 2022-12-22 14:33:37
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-23 15:45:03
 * @Description:
-->
<template>
<div :class="{smallStar: type === 'small', largeStar: type == 'large'}" >
  <img :src="item" alt="" v-for="(item, key) in starArray" :key="key">
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // 星级
    starLevel: {
      type: [String, Number],
      default: 0,
    },
    // 大星-large，小星-small
    type: {
      type: String,
      default: 'small',
    },
  },
  data() {
    // 这里存放数据
    return {
      large: {
        yellow: require('@/assets/bigStar.png'),
        gray: require('@/assets/bigStarGray.png'),
      },
      small: {
        yellow: require('@/assets/star.png'),
        gray: require('@/assets/starGray.png'),
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {
    starArray() {
      const arr = [];
      const starImg = this[this.type];
      for (let i = 0; i < 5; i++) {
        if (i < this.starLevel) {
          arr.push(starImg.yellow);
        } else {
          arr.push(starImg.gray);
        }
      }
      return arr;
    },
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/convert-viewport";

.smallStar{
  display: inline-block;
  line-height: vw(20);
  overflow: hidden;
  img{
    margin-left: vw(3.2);
    margin-right: vw(3.2);
    width: vw(20);
    height: vw(20);
  }
}
.largeStar{
  display: inline-block;
  line-height: vw(30);
  overflow: hidden;
  img{
    margin-left: vw(2.7);
    margin-right: vw(2.7);
    width: vw(30);
    height: vw(30);
  }
}

</style>
